import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	Alert,
} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

import moment from 'moment';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

//redux
import { setRequireCloseModal } from '../../../../slices/powerGenerationHourMeter/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
	addNewPowerGenerationHourMeter,
	updatePowerGenerationHourMeter,
} from '../../../../slices/powerGenerationHourMeter/thunk';
import OSelect from '../../../../Components/OElements/OSelect';
import {
	getFeedingBargesList,
	getPowerGenerationSourceList,
} from '../../../../helpers/establishment/backend_helper';
import {
	addNewBulkNotification,
	addNewFuelSupply,
	getEstablishment,
	getFuelSupplyTypeCode,
	getFuelTank,
	getProductiveCycleActive,
	getUserByRoles,
	sendNewEmailMessage,
} from '../../../../slices/thunks';
import OInput from '../../../../Components/OElements/OInput';
import { useUser } from '../../../../Components/Hooks/useUserHooks';

const PowerGenerationHourMeterForm = ({
	establishment_id,
	dataPowerGenerationHourMeter,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const { user } = useUser();

	const [establishment, setEstablishment] = useState('-');
	const [feedingBarges, setFeedingBarges] = useState('-');
	const [feedingBargesId, setFeedingBargesId] = useState(null);
	const [type, setType] = useState('-');
	const [type_fuel, setTypeFuel] = useState('-');
	const [power_generation_status, setStatus] = useState('-');
	const [hour_meter_last, setHourMeterLast] = useState('-');
	const [date_hour_meter_last, setDateHourMeterLast] = useState(null);
	const [nominal_consumption, setNominalConsumption] = useState('-');
	const [consumption, setConsumption] = useState('-');
	const [errorFuelTank, setErrorFuelTank] = useState(false);
	const [powerGenerationSource, setPowerGenerationSource] = useState(null);

	const selectorPowerGenerationHourMeter = createSelector(
		state => state.PowerGenerationHourMeter,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorPowerGenerationHourMeter);

	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			productive_cycle: establishment.productiveCycleActiveDetail,
			establishment_info: establishment.itemEstablishmentDetail,
			isLoading: establishment.isLoading,
			isSuccess: establishment.isSuccess,
			isError: establishment.isError,
		})
	);
	const {
		productive_cycle,
		establishment_info,
		isLoading,
		isSuccess,
		isError,
	} = useSelector(selectorEstablishments);

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		powerGenerationSource => ({
			itemPowerGenerationSourceList:
				powerGenerationSource.itemPowerGenerationSourceList,
			itemPowerGenerationSourceDetail:
				powerGenerationSource.itemPowerGenerationSourceDetail,
		})
	);
	const { itemPowerGenerationSourceList, itemPowerGenerationSourceDetail } =
		useSelector(selectorPowerGenerationSource);

	const selectorFuelTank = createSelector(
		state => state.FuelTank,
		data => ({
			itemFuelTankDetail: data.itemFuelTankDetail,
			requireCloseModal: data.requireCloseModal,
			isAdding: data.isAdding,
		})
	);
	const { itemFuelTankDetail } = useSelector(selectorFuelTank);

	const selectorFuelSupplyTypeCode = createSelector(
		state => state.FuelSupplyType,
		data => ({
			itemFuelSupplyTypeDetail: data.itemFuelSupplyTypeDetail,
		})
	);
	const { itemFuelSupplyTypeDetail } = useSelector(selectorFuelSupplyTypeCode);

	const selectorUser = createSelector(
		state => state.Roles,
		result => ({
			users: result.itemUserRoleList,
		})
	);

	const [to, setTo] = useState([]);
	const [cc, setCC] = useState([]);

	useEffect(() => {
		const fetchDataTo = async () => {
			const roles = ['MNT'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setTo(response);
			} catch (error) {
				console.error('Error al obtener usuarios TO:', error);
			}
		};

		const fetchDataCc = async () => {
			const roles = ['OPE', 'ADM'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setCC(response);
			} catch (error) {
				console.error('Error al obtener usuarios CC:', error);
			}
		};

		fetchDataTo();
		fetchDataCc();
	}, [dispatch]);

	const [
		itemPowerGenerationSourceListSelect,
		setItemPowerGenerationSourceListSelect,
	] = useState([]);

	useEffect(() => {
		dispatch(getProductiveCycleActive(establishment_id));
		dispatch(getEstablishment(establishment_id));
		dispatch(getFuelSupplyTypeCode('consumption'));
	}, [establishment_id]);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			hour_meter:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.hour_meter) ||
				'',
			power_generation_source_id:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.power_generation_source_id) ||
				'',
			observation:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.observation) ||
				'',
			register_date:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.register_date) ||
				'',
			feeding_barges_id: null,
		},
		validationSchema: Yup.object({
			hour_meter: Yup.number()
				.required('Campo requerido')
				.test(
					'max-capacity',
					'El valor tiene que ser mayor al último registro',
					function (value) {
						const prev =
							hour_meter_last !== null &&
							!isNaN(parseFloat(hour_meter_last))
								? parseFloat(hour_meter_last)
								: -Infinity;
						return value > prev;
					}
				),
			power_generation_source_id: Yup.string().required('Campo requerido'),
			register_date: Yup.string().required('Campo requerido'),
			observation: Yup.string().nullable(),
			feeding_barges_id: Yup.string().nullable(),
		}),
		onSubmit: async values => {
			const prevHour =
				hour_meter_last !== null && !isNaN(parseFloat(hour_meter_last))
					? parseFloat(hour_meter_last)
					: null;
			const powerGenerationHourMeter = {
				power_generation_source_id: values.power_generation_source_id,
				observation: values.observation,
				hour_meter: values.hour_meter,
				productive_cycle_id: productive_cycle._id,
				feeding_barges_id: feedingBargesId,
				establishment_id: establishment_id,
				hour_meter_last: prevHour,
				differences: prevHour !== null ? values.hour_meter - prevHour : 0,
				register_date: values.register_date,
			};

			// Verificar que `consumption` sea válido y que `itemFuelTankDetail` no sea undefined o null
			if (
				consumption !== '-' &&
				itemFuelTankDetail &&
				powerGenerationSource?.calculation_manual === false &&
				prevHour !== null
			) {
				powerGenerationHourMeter.consumption = consumption;
				powerGenerationHourMeter.unit_measurement_id =
					itemFuelTankDetail?.unit_measurement_id ?? null;
				powerGenerationHourMeter.fuel_type_id =
					itemFuelTankDetail?.fuel_type_id ?? null;
			}

			// nominal_consumption

			if (isEdit) {
				powerGenerationHourMeter._id = dataPowerGenerationHourMeter._id;
				dispatch(updatePowerGenerationHourMeter(powerGenerationHourMeter));
			} else {
				const result = await dispatch(
					addNewPowerGenerationHourMeter(powerGenerationHourMeter)
				);
				const source = result.payload.power_generation_source;

				if (
					consumption !== '-' &&
					itemFuelTankDetail &&
					powerGenerationSource?.calculation_manual === false
				) {
					const fuelSupply = {
						amount: consumption,
						supply_date: result.payload.creation_date,
						fuel_tank_id: itemFuelTankDetail._id,
						fuel_type_id: itemFuelTankDetail.fuel_type._id,
						fuel_supply_type_id: itemFuelSupplyTypeDetail._id,
						observation: values.observation,
						productive_cycle_id: productive_cycle._id,
						establishment_id: establishment_id,
						stock: itemFuelTankDetail.stock,
						balance: itemFuelTankDetail.stock - consumption,
						feeding_barges_id: itemFuelTankDetail.feeding_barges_id,
						unit_measurement_id: itemFuelTankDetail.unit_measurement_id,
					};

					dispatch(addNewFuelSupply(fuelSupply));
				}

				// Asigna 0 a source.hour_meter_maintenance si es null
				let hourMeterMaintenance = source.hour_meter_maintenance ?? 0;

				if (values.hour_meter != null && source.hour_maintenance != null) {
					let difference = values.hour_meter - hourMeterMaintenance;
					let percentage = (
						(difference / source.hour_maintenance) *
						100
					).toFixed(0);

					let percentageFormatted =
						Number(percentage).toLocaleString('es-CL');
					let differenceFormatted =
						Number(difference).toLocaleString('es-CL');

					if (percentage > 80) {
						let msg = '';
						if (percentage > 80 && percentage < 90) {
							msg = `Está próximo a alcanzar el límite de horas para la próxima mantención. Actualmente está a un ${percentageFormatted}% (${differenceFormatted} horas acumuladas).`;
						}

						if (percentage > 90) {
							msg = `Ha superado el límite preventivo para la próxima mantención. Actualmente está al ${percentageFormatted}% (${differenceFormatted} horas acumuladas). Por favor, contacte al área responsable.`;

							const subject = `Mantención de Fuente de Generación de Energía (${powerGenerationSource.serial_number.toUpperCase()})`;
							const message = `Se ha registrado un horómetro en el establecimiento ${establishment_info.name.toUpperCase()}, indicando que las horas de uso han superado el ${percentageFormatted}% (${differenceFormatted} horas) respecto al límite para la próxima mantención.`;
							const body = `<div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f9f9f9; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
				
								<div style="text-align: center; margin-bottom: 20px;">
									<h1 style="color: COLOR_SECONDARY;">Mantención de Fuente de Generación de Energía</h1>
								</div>
				
								<p style="margin-bottom: 15px; text-align: justify;">Se informa que la fuente de generación de energía <b>${powerGenerationSource.name.toUpperCase()}</b> ha superado en <b style="color:red;">${percentageFormatted}%</b> el límite de uso, acumulando <b>${differenceFormatted} horas</b>. Se recomienda coordinar su mantención preventiva a la brevedad para garantizar su correcto funcionamiento y evitar posibles fallas.</p>
				
								<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
									<tr>
										<td style="padding: 10px; border: 1px solid #ddd;"><b>Número de Serie</b></td>
										<td style="padding: 10px; border: 1px solid #ddd;">${powerGenerationSource.serial_number.toUpperCase()}</td>
									</tr>
									<tr>
										<td style="padding: 10px; border: 1px solid #ddd;"><b>Modelo</b></td>
										<td style="padding: 10px; border: 1px solid #ddd;">${powerGenerationSource.model.toUpperCase()}</td>
									</tr>
									<tr>
										<td style="padding: 10px; border: 1px solid #ddd;"><b>Marca</b></td>
										<td style="padding: 10px; border: 1px solid #ddd;">${powerGenerationSource.brand.toUpperCase()}</td>
									</tr>
									<tr>
										<td style="padding: 10px; border: 1px solid #ddd;"><b>Tipo</b></td>
										<td style="padding: 10px; border: 1px solid #ddd;">${powerGenerationSource.power_generation_type.name.toUpperCase()}</td>
									</tr>
								</table>
				
								<p style="margin-bottom: 20px;">
									El movimiento fue realizado por <b>${user.full_name.toUpperCase()}</b>.
								</p>
				
								<div style="margin-top: 30px; text-align: center;">
									<p>Si tienes alguna pregunta o necesitas asistencia, por favor <a href="mailto:ayuda@openlink.cl" style="color: COLOR_SECONDARY;">contáctanos</a>.</p>
									<p>Gracias. Equipo de Openlink.</p>
								</div>
				
							</div>`;

							if (to.length > 0) {
								const uniqueEmailsTo = [
									...new Set(to.map(user => user.email)),
								].join(',');
								const uniqueEmailsCc = [
									...new Set(cc.map(user => user.email)),
								].join(',');
								const message_email = {
									to_email: uniqueEmailsTo,
									subject: subject,
									body: body,
									cc_email: uniqueEmailsCc,
								};
								dispatch(sendNewEmailMessage(message_email));
							}
						}

						toast.error(msg, { autoClose: 6000 });
						const user_ids = [...new Set(to.map(user => user._id))];
						const message_notification = {
							title: subject,
							message: message,
							notification_priority_code: 'M',
							notification_type_code: 'ADV',
							user_ids: user_ids,
						};
						dispatch(addNewBulkNotification(message_notification));
					}
				}
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	const handlePowerGenerationSourceSelect = optionSelected => {
		setPowerGenerationSource(optionSelected);
	};

	useEffect(() => {
		if (powerGenerationSource) {
			dispatch(getFuelTank(powerGenerationSource.fuel_tank_id));
		}
	}, [powerGenerationSource]);

	const handleConsumption = event => {
		const { name, value } = event.target;

		// Convertir `value` a número
		const parsedValue = parseFloat(value);

		// Validar si `hour_meter_last` es un número válido; si no, dejarlo como null para indicar que no existe lectura previa
		const parsedHourMeterLast =
			hour_meter_last !== null && !isNaN(parseFloat(hour_meter_last))
				? parseFloat(hour_meter_last)
				: null;

		// Validar si `nominal_consumption` es un número válido
		const parsedNominalConsumption = parseFloat(nominal_consumption);

		// Verificar si existe lectura previa y si `value` es válido y >= a `hour_meter_last`
		if (
			!powerGenerationSource?.calculation_manual &&
			parsedHourMeterLast !== null &&
			!isNaN(parsedValue) &&
			!isNaN(parsedNominalConsumption) &&
			parsedValue >= parsedHourMeterLast
		) {
			let consumption_value = Math.round(
				(parsedValue - parsedHourMeterLast) * parsedNominalConsumption
			);
			setConsumption(consumption_value);
			if (itemFuelTankDetail) {
				setErrorFuelTank(consumption_value > itemFuelTankDetail.stock);
			}
		} else {
			setConsumption('-');
			setErrorFuelTank(false);
		}

		validation.setFieldValue(name, value);
	};

	useEffect(() => {
		if (powerGenerationSource) {
			setEstablishment(powerGenerationSource.Establishment?.name);
			setFeedingBarges(powerGenerationSource.feeding_barges?.name);
			setFeedingBargesId(powerGenerationSource.feeding_barges?._id);
			setType(powerGenerationSource.power_generation_type.name);
			setTypeFuel(powerGenerationSource.fuel_type.name);
			setStatus(powerGenerationSource.power_generation_status.name);
			setHourMeterLast(
				powerGenerationSource.hour_meter !== undefined &&
					powerGenerationSource.hour_meter !== null
					? powerGenerationSource.hour_meter
					: null
			);
			setNominalConsumption(powerGenerationSource.nominal_consumption);
			setDateHourMeterLast(
				powerGenerationSource.date_hour_meter
					? dayjs(powerGenerationSource.date_hour_meter).format(
							'DD-MM-YYYY'
					  )
					: null
			);
		} else {
			setFeedingBarges('-');
			setFeedingBargesId(null);
			setType('-');
			setTypeFuel('-');
			setStatus('-');
			setHourMeterLast('-');
			setDateHourMeterLast('-');
			setNominalConsumption('-');
			setConsumption('-');
		}
	}, [powerGenerationSource]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) {
					toast.error(
						'Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.',
						{ autoClose: 4000 }
					);
				}
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					{!Array.isArray(itemPowerGenerationSourceList) && (
						<Col lg={12}>
							<Alert color='info'>
								{itemPowerGenerationSourceDetail?.error}
							</Alert>
						</Col>
					)}

					{errorFuelTank && (
						<Col lg={12}>
							<div
								className='alert alert-danger alert-dismissible alert-label-icon rounded-label fade show'
								role='alert'
							>
								<i className={`${Icons.alert} label-icon`}></i>
								<strong>Verificación de Combustible</strong> El consumo
								de combustible registrado por la fuente de generación de
								energía excede la cantidad disponible en el estanque de
								combustible, resultando en un saldo negativo.
								<br />
								Por favor, verifique que el estanque cuente con
								suficiente combustible antes de completar esta acción.
							</div>
						</Col>
					)}

					{['SWE', 'LWE'].includes(
						establishment_info?.establishment_type?.code
					) && (
						<Col lg={3}>
							<OSelect
								label='Artefacto Naval'
								id='feeding_barges_id'
								name='feeding_barges_id'
								value={validation.values.feeding_barges_id || ''}
								// onSelect={handleFeedingBargesSelect}
								requestApi={() =>
									getFeedingBargesList({
										establishment_id: establishment_id,
									})
								}
								validation={validation}
							/>
						</Col>
					)}
					<Col lg={3}>
						<OSelect
							key={
								'power_generation_source_id' +
								establishment_id +
								validation.values.feeding_barges_id
							}
							label='Fuente de Generación de Energía'
							id='power_generation_source_id'
							name='power_generation_source_id'
							handleLabelOptions={item =>
								item.name +
								(item?.serial_number ? ' - ' + item?.serial_number : '')
							}
							isRequired={true}
							value={validation.values.power_generation_source_id || ''}
							onSelect={handlePowerGenerationSourceSelect}
							// requestApi={() => getPowerGenerationSourceList({ establishment_id: establishment_id })}
							requestApi={() => {
								return getPowerGenerationSourceList({
									establishment_id: establishment_id,
								}).then(options => {
									const filteredOptions = options.filter(
										option =>
											option.feeding_barges_id ==
											validation.values.feeding_barges_id
									);
									return filteredOptions;
								});
							}}
							validation={validation}
						/>
					</Col>
					<Col lg={2}>
						<OInput
							name='type'
							label='Tipo'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={type}
							disabled={true}
						/>
					</Col>
					<Col lg={2}>
						<OInput
							name='type_fuel'
							label='Tipo Combustible'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={type_fuel}
							disabled={true}
						/>
					</Col>
					<Col lg={2}>
						<OInput
							name='power_generation_status'
							label='Estado'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={power_generation_status}
							disabled={true}
						/>
					</Col>
				</Row>
				<Row className='g-3 mt-1'>
					<Col lg={2}>
						<OInput
							name='hour_meter'
							label='Horómetro Actual'
							type='number'
							onChange={handleConsumption}
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							isRequired={true}
						/>
					</Col>
					<Col sm={2}>
						<DatesProvider
							settings={{
								locale: 'es-mx',
								firstDayOfWeek: 1,
								weekendDays: [0],
								timezone: 'UTC',
							}}
						>
							<DatePickerInput
								label={
									<span>
										Fecha de Registro{' '}
										<span style={{ color: 'red' }}>*</span>
									</span>
								}
								id='register_date'
								name='register_date'
								placeholder='Seleccione una fecha'
								value={
									validation.values.register_date
										? new Date(validation.values.register_date)
										: null
								}
								onChange={date => {
									validation.setFieldValue('register_date', date);
								}}
								onBlur={validation.handleBlur}
								valueFormat='DD-MM-YYYY'
								maxDate={new Date()}
								// minDate={new Date(new Date().setDate(new Date().getDate() - 5))} // Set minDate to 5 days before today
								minDate={
									user?.role_code === 'CTO'
										? Math.max(
												new Date(
													new Date().getFullYear(),
													new Date().getMonth(),
													1
												),
												!date_hour_meter_last ||
													date_hour_meter_last === '-'
													? new Date(
															new Date().setDate(
																new Date().getDate() - 365
															)
													  )
													: moment(
															date_hour_meter_last,
															'DD-MM-YYYY'
													  ).toDate()
										  )
										: !date_hour_meter_last ||
										  date_hour_meter_last === '-'
										? new Date(
												new Date().setDate(
													new Date().getDate() - 365
												)
										  )
										: moment(
												date_hour_meter_last,
												'DD-MM-YYYY'
										  ).toDate()
								}
								error={
									validation.touched['register_date'] &&
									validation.errors['register_date']
										? validation.errors['register_date']
										: ''
								}
								clearable={true}
							/>
						</DatesProvider>
					</Col>

					<Col lg={2}>
						<Label for='hour_meter_last' className='form-label'>
							Último Registro
						</Label>
						<Input
							name='hour_meter_last'
							id='hour_meter_last'
							className='form-control'
							placeholder='-'
							type='text'
							disabled={true}
							value={hour_meter_last}
						/>
					</Col>

					<Col lg={2}>
						<Label for='date_hour_meter_last' className='form-label'>
							Fecha Último Registro
						</Label>
						<Input
							name='date_hour_meter_last'
							id='date_hour_meter_last'
							className='form-control'
							placeholder='-'
							type='text'
							disabled={true}
							value={date_hour_meter_last}
						/>
					</Col>

					{powerGenerationSource?.calculation_manual === false && (
						<>
							<Col lg={2}>
								<Label for='nominal_consumption' className='form-label'>
									Consumo Nominal (
									{powerGenerationSource?.fuel_type_unit_measurement
										?.name || '-'}
									)
								</Label>
								<Input
									name='nominal_consumption'
									id='nominal_consumption'
									className='form-control'
									placeholder='-'
									type='text'
									disabled
									value={nominal_consumption || ''}
								/>
							</Col>

							<Col lg={2}>
								<Label for='consumption' className='form-label'>
									Consumo (
									{itemFuelTankDetail?.unit_measurement?.name || '-'})
								</Label>
								<Input
									name='consumption'
									id='consumption'
									className='form-control'
									placeholder='-'
									type='text'
									disabled
									value={consumption || ''}
								/>
							</Col>
						</>
					)}

					<Col lg={12}>
						<Label for='observation' className='form-label'>
							Observación
						</Label>
						<Input
							name='observation'
							id='observation'
							className='form-control'
							placeholder='Ingrese una observación'
							type='textarea'
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.observation || ''}
							invalid={
								validation.touched.observation &&
								validation.errors.observation
									? true
									: false
							}
						/>
						{validation.touched.observation &&
							validation.errors.observation && (
								<FormFeedback type='invalid'>
									{validation.errors.observation}
								</FormFeedback>
							)}
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating || errorFuelTank}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'>
								<Spinner size='sm' />
							</i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Registrar'} Horómetro
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PowerGenerationHourMeterForm;
